import React from "react";
import './CompanyCulture.css'
import { Link } from "react-router-dom";
import Projectsimage from '../../assets/Projects/ongoingProjects.png'
import ourCulture from '../../assets/CompanyCulture/ourculture.png'
import value1 from '../../assets/CompanyCulture/value1.png'
import value2 from '../../assets/CompanyCulture/value2.png'
import value3 from '../../assets/CompanyCulture/value3.png'
import value4 from '../../assets/CompanyCulture/value4.png'
import value5 from '../../assets/CompanyCulture/value5.png'
import BlueRightArrow from '../../assets/Contactus/blue-right-arrow.png'


import ourcertifications1 from '../../assets/CompanyCulture/Certifications1.png'
import ourcertifications2 from '../../assets/CompanyCulture/Certifications2.png'
import ourcertifications3 from '../../assets/CompanyCulture/Certifications3.png'

import info1 from '../../assets/CompanyCulture/info1.png'
import info2 from '../../assets/CompanyCulture/info2.png'
import info3 from '../../assets/CompanyCulture/info3.png'

import graph from '../../assets/CompanyCulture/graphimage.png'

const CompanyCulture = () =>{
     const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' }); // or 'auto'
  };
    return(
       <>
         {/* <div className="projects-section-main-container">
            <img src={Projectsimage} alt="projects" className="ongoing-project-home-image"/>
            <h1 className="projects-main-heading">Our People, Our Culture</h1>
            <p className="projects-main-content">At TAUC, our people and values are at the heart of everything we achieve.</p>
        </div> */}

        <div className="company-culture-image-container">
        <div className="overlay-text-container-company">
          <h1 className="about-main-heading-company">Our People, Our Culture</h1>
          <p className="about-main-description-company">At TAUC, our people and values are at the heart of everything we achieve.</p>
        </div>
      </div>

        <div className="our-culture-main-container">
            <h1 className="our-culture-heading">Our Culture</h1>
            
            <div className="our-culture-card-container">
                <div className="our-culture-image-container">
                    <img src={ourCulture} alt="our-culture" className="our-culture-image"/>
                </div>
                <div className="our-culture-description-card">
                    <p className="our-culture-description">Since 2001, TAUC has built a culture of teamwork, responsibility, and integrity. We empower our people to grow, innovate, and succeed together, ensuring a safe and inclusive environment where every voice matters and every contribution counts.</p>
                </div>
            </div>
        </div>

         <div className="our-culture-main-container">
            <h1 className="our-culture-heading">Caring for Our People</h1>

            <div className="caring-people-main-card-container">
                <div className="caring-people-card">
                    <img src={graph} alt="graph-image" className="graph-main-image"/>
                    <div className="caring-people-graph-container">
                        <div className="color-info-container">
                            <img src={info3} alt="info-color" className="graph-color"/>
                            <p className="graph-info">60% Fitness & Wellness Programs</p>
                        </div>
                        <div className="color-info-container">
                            <img src={info2} alt="info-color" className="graph-color"/>
                            <p className="graph-info">25% Mental Health & Counseling</p>
                        </div>
                        <div className="color-info-container">
                            <img src={info1} alt="info-color" className="graph-color"/>
                            <p className="graph-info">60% Fitness & Wellness Programs</p>
                            <p className="graph-info">15% Work-Life Balance</p> 
                        </div>
                        <p className="graph-description">We invest in the wellbeing of our people through comprehensive health, wellness, and balance initiatives that support both personal and professional growth.</p>
                    </div>
                </div>
            </div>
        </div>

        <div className="our-culture-main-container">
            <h1 className="our-culture-heading">Our Values</h1>

            <div className="our-value-main-cards-container">

                <div className="our-value-card our-value-card-1">
                    <img src={value1} alt="value-logo" className="value-logo"/>
                    <div className="value-content-container">
                        <h1 className="our-value-title">We Value Our People</h1>
                        <p className="our-value-description">Our team members are our greatest asset and the foundation of our success.</p>
                    </div>
                </div>

                <div className="our-value-card our-value-card-2">
                    <img src={value3} alt="value-logo" className="value-logo"/>
                    <div className="value-content-container">
                        <h1 className="our-value-title">We Deliver</h1>
                        <p className="our-value-description">Excellence in execution and commitment to exceeding expectations every time.</p>
                    </div>
                </div>

                <div className="our-value-card our-value-card-3">
                    <img src={value4} alt="value-logo" className="value-logo"/>
                    <div className="value-content-container">
                        <h1 className="our-value-title">We Act with Integrity</h1>
                        <p className="our-value-description">Honesty, transparency, and ethical behavior guide everything we do.</p>
                    </div>
                </div>

                <div className="our-value-card our-value-card-4">
                    <img src={value5} alt="value-logo" className="value-logo"/>
                    <div className="value-content-container">
                        <h1 className="our-value-title">We Empower</h1>
                        <p className="our-value-description">Creating opportunities for growth, innovation, and personal development.</p>
                    </div>
                </div>

                <div className="our-value-card our-value-card-5">
                    <img src={value2} alt="value-logo" className="value-logo"/>
                    <div className="value-content-container">
                        <h1 className="our-value-title">We Are a Team of Teams</h1>
                        <p className="our-value-description">Collaboration across all levels creates unstoppable momentum and shared success.</p>
                    </div>
                </div>
            </div>
        </div>

        <div className="our-culture-main-container">
            <h1 className="our-culture-heading">Our Certifications</h1>

            <div className="our-certifications-main-cards-container">
                <div className="our-certifications-card">
                    <img src={ourcertifications1} alt="our-certifications-image" className="our-certifications-image" />
                    <h1 className="our-certification-number">ISO 9001:2015</h1>
                    <p className="our-certification-description">Quality Management System certification ensuring consistent, high-quality service delivery.</p>
                </div>

                <div className="our-certifications-card">
                    <img src={ourcertifications2} alt="our-certifications-image" className="our-certifications-image" />
                    <h1 className="our-certification-number">ISO 14001:2015</h1>
                    <p className="our-certification-description">Environmental Management System demonstrating our commitment to sustainability.</p>
                </div>

                <div className="our-certifications-card">
                    <img src={ourcertifications3} alt="our-certifications-image" className="our-certifications-image" />
                    <h1 className="our-certification-number">ISO 45001:2018</h1>
                    <p className="our-certification-description">Occupational Health & Safety Management System prioritizing worker wellbeing.</p>
                </div>
            </div>
            <p className="our-certification-footer-description">Our certifications reflect TAUC's commitment to quality, safety, and sustainability across all projects, ensuring we meet the highest industry standards.</p>
        </div>

        <div className="contact-us-main-container">
            <h1 className="contact-us-heading">Let's Build the Future Together</h1>
            <p className="contact-us-content">Ready to start your next project? Partner with TAUC for engineering excellence and construction expertise you can trust.</p>
            {/* <button className="contact-us-button">Contact Us Today </button> */}
            <Link to="/contact" onClick={scrollToTop} className="buttonStyleContact" style={{ color: "#1E3A8A" , textDecoration:"none"}}>
          Contact Us Today <img src={BlueRightArrow} alt="blue-right-arrow" className="blue-right-arrow" />
        </Link>
        </div>

       </>
    )
}

export default CompanyCulture